  /* =============================================================
   PDP Media Auto-Pause on Scroll-Out
   -------------------------------------------------------------
   Pauses native <video>, YouTube iframes, and Vimeo iframes
   inside .t4s-main-product__content when they scroll out of
   view (>70% out). Uses IntersectionObserver — no scroll listeners.
   Safe to defer; auto-detects late-added media via MutationObserver.
   ============================================================= */
  (function () {
    'use strict';

    function init() {
      var scope = document.querySelector('.t4s-main-product__content');
      if (!scope || !('IntersectionObserver' in window)) return;

      /* ── Helper: pause any media element ───────────────────── */
      function pauseMedia(el) {
        if (!el) return;

        if (el.tagName === 'VIDEO') {
          try {
            el.pause();
          } catch (e) {}
          return;
        }

        if (el.tagName === 'IFRAME') {
          var src = el.getAttribute('src') || '';
          if (!src) return;
          try {
            if (src.indexOf('youtube.com') !== -1 || src.indexOf('youtu.be') !== -1) {
              el.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
            } else if (src.indexOf('vimeo.com') !== -1) {
              el.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
            }
            /* Unknown iframe types: do nothing (no crash) */
          } catch (e) {}
        }
      }

      /* ── Inject enablejsapi=1 into YouTube iframes ─────────── */
      function enableYouTubeApi(iframe) {
        var src = iframe.getAttribute('src') || '';
        if (!src) return;
        var isYT = src.indexOf('youtube.com') !== -1 || src.indexOf('youtu.be') !== -1;
        if (!isYT) return;
        if (src.indexOf('enablejsapi=1') !== -1) return;
        var sep = src.indexOf('?') === -1 ? '?' : '&';
        iframe.setAttribute('src', src + sep + 'enablejsapi=1');
      }

      /* ── IntersectionObserver: pause when >70% out of view ─ */
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.3) {
              pauseMedia(entry.target);
            }
          });
        },
        { threshold: [0, 0.3, 0.7, 1] }
      );

      /* ── Attach to all current and future media ────────────── */
      function observe(el) {
        if (!el || el.dataset.pauseObserved === 'true') return;
        el.dataset.pauseObserved = 'true';
        if (el.tagName === 'IFRAME') enableYouTubeApi(el);
        io.observe(el);
      }

      function scanAndObserve() {
        var nodes = scope.querySelectorAll('video, iframe');
        for (var i = 0; i < nodes.length; i++) observe(nodes[i]);
      }

      scanAndObserve();

      /* ── Watch for late-added media (variant change, Flickity, AJAX) ── */
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'VIDEO' || n.tagName === 'IFRAME') {
              observe(n);
            } else if (n.querySelectorAll) {
              var children = n.querySelectorAll('video, iframe');
              for (var k = 0; k < children.length; k++) observe(children[k]);
            }
          }
        }
      });
      mo.observe(scope, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
